<template>
  <div
    class="my_collapse_item c-custom_my_collapse_item"
    ref="my_collapse_item"
    :class="{ 'is_active': isActive }"
  >
    <div
      class="my_collapse_item_header"
      @click="handleHeaderClick"
    >
      <i class="my_collapse_item_icon_arrow el-icon-caret-right"></i>
      <span>{{ title }}</span>
      <div class="my_collapse_item_line"></div>
    </div>
    <transition
      name="collapse"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <div
        class="my_collapse_item_body"
        v-if="isActive"
        ref="my_collapse_item_body"
      >
        <div class="my_collapse_item_body_wrap">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import i18n from '../../language/index'

import Emitter from './Emitter'

export default {
  name: 'my_collapse_item',
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'default'
    }
  },
  mixins: [Emitter],
  inject: ['collapse'],
  computed: {
    isActive () {
      return this.collapse.activeNames.includes(this.name)
    }
  },
  mounted () {
    if (this.$refs.my_collapse_item_body) {
      this.$refs.my_collapse_item_body.style.height = this.$refs.my_collapse_item_body.offsetHeight + 'px'
    }
  },
  methods: {
    handleHeaderClick () {
      this.dispatch('my_collapse', 'item-click', this)
    },
    beforeEnter (el) {
      el.style.height = 0
    },
    enter (el) {
      if (el.scrollHeight !== 0) {
        el.style.height = el.scrollHeight + 'px'
      } else {
        el.style.height = 0
      }
    },
    beforeLeave (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave (el) {
      el.style.height = 0
    },
    afterLeave (el) {
      el.style.height = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.my_collapse_item {
  .my_collapse_item_header {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    font-size: 14px;
    .my_collapse_item_icon_arrow {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      vertical-align: middle;
      transition: all 0.2s;
    }
    .my_collapse_item_line {
      flex: 1;
      margin-left: 10px;
      height: 1px;
      opacity: 0;
      border: 1px dashed #def0ff;
    }
  }
  &.is_active {
    .my_collapse_item_header {
      color: #0078d7;
      .my_collapse_item_icon_arrow {
        transform: rotate(90deg);
      }
      .my_collapse_item_line {
        opacity: 1;
      }
    }
  }
  .my_collapse_item_body {
    overflow: hidden;
    transition: all 0.2s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_collapse/my_collapse_item.vue